import { render } from "./DraftDeliverySlip.vue?vue&type=template&id=3f218b36&scoped=true&ts=true"
import script from "./DraftDeliverySlip.vue?vue&type=script&lang=ts"
export * from "./DraftDeliverySlip.vue?vue&type=script&lang=ts"

import "./DraftDeliverySlip.vue?vue&type=style&index=0&id=3f218b36&scoped=true&lang=scss"

import exportComponent from "D:\\02_システム\\20_帳票テンプレート\\02_開発\\report-template\\web-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f218b36"]])

export default __exports__